module.exports = __webpack_public_path__ + "static/media/loc2_img5.f6598bf7.jpg";